$(document).ready(function() {
  $('.reveal-block').click(function(e) {
    e.preventDefault();

    var targetBlock = $(this).data('target');
    console.log(targetBlock);

    $(targetBlock).removeClass('hidden');
    $(this).parents('.button-wrapper').hide();
  });

  $('.participants-number').on('change', function() {

    var valueChanged     = parseInt($(this).val(), 10);

    var i = 1;
    $(document).find('.panel-default').each(function(){
      if (i <= valueChanged) {
        $(this).removeClass('hide').show();
      } else {
        $(this).hide();
      }
      i++;
    });
    // var valueChanged     = parseInt($(this).val(), 10);
    // var mainContainer    = $('.participant-wrapper');
    // var mainElement      = $('.participant-wrapper > .panel');
    // var lastMainElement  = $('.participant-wrapper > .panel:last-child');
    // var firstMainElement = $('.participant-wrapper > .panel:first-child');
    // var mainElementClone = firstMainElement.clone();
    // var actualQuantity   = mainElement.length;
    // var quantityToAdd    = valueChanged - actualQuantity;

    // if (quantityToAdd > 0) {
    //   mainElementClone.removeClass('saved');
    //   mainElementClone.find('.panel-title > a').addClass('collapsed');
    //   mainElementClone.find('.panel-collapse').removeClass('in');
    //   mainElementClone.find('.form-control').val('');

    //   var title = mainElementClone.find('.panel-title > a .title').data('title');
    //   var id = mainElementClone.find('.panel-collapse').attr('id');

    //   title = title.substr(0, title.length - 1);
    //   id = id.substr(0, id.length - 1);

    //   for (var i = 1; i <= quantityToAdd; i++) {
    //     var number = actualQuantity + i;
    //     var newClone = mainElementClone.clone();

    //     newClone.find('.panel-title > a .title').text(title + number);
    //     newClone.find('.panel-title > a').attr('href', '#'+id+number);
    //     newClone.find('.panel-collapse').attr('id', id+number);
    //     mainContainer.append(newClone);
    //   }
    //   showSendForm();
    //   return false;
    // } else {
    //   var quantityToRemove = Math.abs(quantityToAdd);
    //   for (var i = 1; i <= quantityToRemove; i++) {
    //     $('.participant-wrapper > .panel:last-child').remove();
    //   }
    //   showSendForm();
    // }
  });

  $('.participants-number').change();

  $('.participant-wrapper').on('input change blur', 'input.participant-name', function() {
    console.log($(this).val())

    var newValue = $(this).val();
    var mainElement = $(this).parents('.panel').find('.panel-title > a .title');
    var mainTitle = mainElement.data('title');

    if (newValue.length) {
      mainElement.text(newValue);
      return;
    }

    mainElement.text(mainTitle);
  });

  $('.participant-wrapper').on('click', '.save-participant', function(e) {
    e.preventDefault();

    var parentElement = $(this).parents('.panel');

    parentElement.find('.panel-collapse').collapse('hide');
    parentElement.addClass('saved');
    parentElement.find('.panel-title > a').addClass('collapsed');

    showSendForm();
  });

  function showSendForm() {
    if ($('.participant-wrapper .panel').length <=
        $('.participant-wrapper .panel.saved').length) {
      $('.send-team').removeClass('hidden');

      var savePosition = $('.send-team').offset().top - $('#site-header').height() - 30;

      $('html, body').animate({scrollTop: savePosition}, 650);
    } else {
      $('.send-team').addClass('hidden');
    }
  }
});
